import React from 'react'
import Dialog from '@mui/material/Dialog'
import { Button } from '@mui/material'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'

const CustomConfirm = ({ open, onClose, onClickNG, onClickOK, message, isProcessing}) => {
return (
  <>
        <Dialog open={open} onClose={onClose}>
        <DialogContent>
            <DialogContentText>
            {message}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClickNG} color="primary">キャンセル</Button>
            <Button onClick={onClickOK} color="primary">続行</Button>
        </DialogActions>
        </Dialog>

        {isProcessing && (
        <div className="overlay">
            <div className="overlay-message">
            処理を実行しています。画面はそのままでお待ちください…
            </div>
        </div>
        )}
  </>
);

}

export default CustomConfirm